import { type PropsWithChildren } from 'react'

import { ThemePreferences } from '@/types/platform'

import PrimaryColorProvider from '../primary-color'

type MantineProviderProps = PropsWithChildren<{
  initialTheme: ThemePreferences
}>

const MantineProvider = (props: MantineProviderProps) => {
  const { children, initialTheme } = props

  return (
    <PrimaryColorProvider initialTheme={initialTheme}>{children}</PrimaryColorProvider>
  )
}

export default MantineProvider
